import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
// TODO: Implement the SecondaryKevelBanners component
export const SecondaryKevelBanners = (_props) => {
    return _jsx(_Fragment, {});
};
//# sourceMappingURL=SecondaryKevelBanners.js.map